import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Row, Col, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Translate, translate } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { generateCaptcha } from 'app/modules/account/password-reset/password-reset.reducer';
import { IRootState } from 'app/shared/reducers';
import 'app/modules/account/password-reset/passwordReset.scss';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { SUCCESS } from 'app/config/constants';

export interface IModalCaptchaProps extends StateProps, DispatchProps, RouteComponentProps<{ key: any }> {}

export interface IModalCaptchaProps {
  showModalCaptcha: boolean;
  invokeCancel: Function;
  invokeAgree: Function;
  dismissAlert: Function;
  errMessage: string;
  isOpenAlert: boolean;
  mobile: string;
  fullName: string;
  email: string;
}

export interface IModalCaptchaInitState {
  captcha: string;
  messageAlert: string;
}

class ModalInputCaptcha extends React.Component<IModalCaptchaProps, IModalCaptchaInitState> {
  state: IModalCaptchaInitState = {
    captcha: '',
    messageAlert: ''
  };
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.responseCap !== nextProps.responseCap) {
      const { responseCap } = nextProps;
      if (responseCap.status === SUCCESS) {
        this.setState({
          captcha: responseCap.message
        });
      }
    }
  }
  componentWillMount() {
    this.props.generateCaptcha();
  }

  invokeResetCaptcha = () => {
    this.props.generateCaptcha();
  };

  handleValidSubmit = values => {
    this.props.invokeAgree(values);
  };

  toggle = () => {
    this.props.invokeCancel();
  };

  onDismiss = () => {
    this.props.dismissAlert();
  };

  render() {
    let { email, mobile, fullName } = this.props;
    return (
      <div>
        <Modal style={{ maxWidth: '600px' }} isOpen={this.props.showModalCaptcha} toggle={this.toggle} centered>
          <ModalHeader toggle={this.toggle} />
          <Alert color="danger" isOpen={this.props.isOpenAlert} toggle={this.onDismiss}>
            {this.props.errMessage}
          </Alert>
          <ModalBody>
            <Row className="justify-content-center">
              <Col className="box-otp" style={{ maxWidth: '560px' }}>
                <h2 className="text-center font-weight-bold" id="password-title">
                  Chọn phương thức xác thực
                </h2>
                <h6 className="text-center txtContent font-weight-bold">
                  <p>Chào mừng bạn đến với Nền tảng quản lý định danh và xác thực</p>
                  <p>Ngành tài nguyên và môi trường</p>
                  <p>
                    Tài khoản: <span className="font-weight-bold">{fullName}</span>
                  </p>
                  <p>Chọn phương thức xác thực</p>
                </h6>

                <Button className="btn-register-white" type="button" block onClick={() => this.handleValidSubmit('EMAIL')}>
                  <span>Xác thực Email: {email}</span>
                </Button>
                <Button className="btn-register-white" type="button" block onClick={() => this.handleValidSubmit('SMS')}>
                  <span>Xác thực điện thoại di động: {mobile}</span>
                </Button>
              </Col>
            </Row>
          </ModalBody>
          {/* <ModalFooter>

          </ModalFooter> */}
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = ({ passwordReset }: IRootState) => ({
  responseCap: passwordReset.responseCaptcha
});

const mapDispatchToProps = { generateCaptcha };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalInputCaptcha);
